import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import TrainingTableComponent from "../../../components/tables/TrainingTableComponent";
import axios from "axios";

export default function Trainings() {
  const { t } = useContext(TranslatorContext);

  const [trainings, setTrainings] = useState([]);
  const [allTrainings, setAllTrainings] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [courseFilter, setCourseFilter] = useState("");
  const [instituteFilter, setInstituteFilter] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchTrainings();
  }, []);

  const fetchTrainings = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL +
        "/vocational-trainings"
      );

      const mappedData = res.data.data.map(
        (training) => ({
          id: training.id,
          f_number: training.f_number,
          student_name:
            training.student_name,
          relation: training.relation,
          institute_name:
            training.institute_name,
          training_name:
            training.training_name,
          training_duration:
            training.duration,
          total_fees: training.fee,
          status: training.completed,
          action: {
            edit: "edit",
            delete: "delete",
          },
        })
      );

      setTrainings(mappedData);
      setAllTrainings(mappedData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let filtered = [...allTrainings];

    // Search
    if (search) {
      filtered = filtered.filter(
        (item) =>
          item.student_name
            ?.toLowerCase()
            .includes(
              search.toLowerCase()
            ) ||
          item.f_number
            ?.toLowerCase()
            .includes(
              search.toLowerCase()
            )
      );
    }

    // Status Filter
    if (statusFilter !== "") {
      filtered = filtered.filter(
        (item) =>
          String(item.status) ===
          statusFilter
      );
    }

    // Course Filter
    if (courseFilter) {
      filtered = filtered.filter(
        (item) =>
          item.training_name ===
          courseFilter
      );
    }

    // Institute Filter
    if (instituteFilter) {
      filtered = filtered.filter(
        (item) =>
          item.institute_name ===
          instituteFilter
      );
    }

    setTrainings(filtered);
  }, [
    search,
    statusFilter,
    courseFilter,
    instituteFilter,
    allTrainings,
  ]);

  const institutes = [
    ...new Set(
      allTrainings
        .map(
          (item) =>
            item.institute_name
        )
        .filter(Boolean)
    ),
  ];

  const courses = [
    ...new Set(
      allTrainings
        .map(
          (item) =>
            item.training_name
        )
        .filter(Boolean)
    ),
  ];
  const statuses = [
    ...new Set(
      allTrainings
        .map(
          (item) =>
            item.status
        )
        .filter(Boolean)
    ),
  ];
  const resetFilters = () => {
    setSearch("");
    setStatusFilter("");
    setCourseFilter("");
    setInstituteFilter("");
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                Vocational Trainings ({trainings.length} )
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    {t("home")}
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    {t(
                      "Vocational Trainings"
                    )}
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">
                  All Trainings List
                </li>
              </ul>
            </div>
          </div>
        </Col>

        <Col xl={12}>
          <div className="mc-card">


            {/* Filters */}
            <Row className="mb-4">
              <Col md={3}>
                <Form.Control
                  type="text"
                  placeholder="Search Family / Student"
                  value={search}
                  onChange={(e) =>
                    setSearch(
                      e.target.value
                    )
                  }
                />
              </Col>

              <Col md={2}>
                <Form.Select
                  value={statusFilter}
                  onChange={(e) =>
                    setStatusFilter(
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    All Status
                  </option>

                  {statuses.map(
                    (status, index) => (
                      <option
                        key={index}
                        value={status}
                      >
                        {status}
                      </option>
                    )
                  )}
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Select
                  value={courseFilter}
                  onChange={(e) =>
                    setCourseFilter(
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    All Courses
                  </option>

                  {courses.map(
                    (course, index) => (
                      <option
                        key={index}
                        value={course}
                      >
                        {course}
                      </option>
                    )
                  )}
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Select
                  value={instituteFilter}
                  onChange={(e) =>
                    setInstituteFilter(
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    All Institutes
                  </option>

                  {institutes.map(
                    (
                      institute,
                      index
                    ) => (
                      <option
                        key={index}
                        value={
                          institute
                        }
                      >
                        {institute}
                      </option>
                    )
                  )}
                </Form.Select>
              </Col>

              <Col md={1}>
                <Button
                  variant="secondary"
                  onClick={
                    resetFilters
                  }
                >
                  Reset
                </Button>
              </Col>
            </Row>

            <Row>
              <Col xl={12}>
                <TrainingTableComponent
                  thead={[
                    "Family",
                    "Student's Name",
                    "Relation",
                    "Institute's Name",
                    "Training Name",
                    "Training Duration",
                    "Total Fees",
                    "Status",
                    "Actions",
                  ]}
                  tbody={trainings}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}